module.exports = __webpack_public_path__ + "img/close.7a72cbf9.svg";